import React, { useContext } from 'react';
import { DesktopHeader } from './layouts/DesktopHeader';
import { MobileHeader } from './layouts/MobileHeader';
import { useResponsive } from '@app/hooks/useResponsive';
import { VariantContext } from '@app/variant';
import { useRoutesByVariant } from '@app/hooks/useRoutesByVariant';

interface HeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
  isTwoColumnsLayout: boolean;
}

export const Header: React.FC<HeaderProps> = ({ toggleSider, isSiderOpened, isTwoColumnsLayout }) => {
  const { isTablet } = useResponsive();
  const { id } = useContext(VariantContext);
  const routes = useRoutesByVariant(id);

  if (!routes) return null; // or show a spinner

  return isTablet ? (
    <DesktopHeader isTwoColumnsLayout={false} routes={routes} />
  ) : (
    <MobileHeader toggleSider={toggleSider} isSiderOpened={isSiderOpened} />
  );
};
